import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Bottom from "../Bottom";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import noticeimg from "../../assets/images/noticeimg.png";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useEffect } from "react";
import api from "../../utils/api";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { Button, Chip } from '@mui/material';
import { notifyApiError } from "../../utils/apiError";

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const Event = () => {
  const navigate = useNavigate();
  const [eventList, setEventList] = React.useState([]);

  let i = 0;
  useEffect(() => {
    let params = { cusId: localStorage.getItem('userCusID') || '', pageNum: 0, searchWord: '' };

    let i = 0;
    while (true) { // 조건문
      let listCount = 0;
      params.pageNum = i;
      api.post(`customer/api/v1/CU_010_001`, params).then(res => {
        setEventList((prev) => prev.concat(res.data.eventList));
        listCount = res.data.eventList.length;
      }).catch(function (error) {
        console.log(error)
      });

      if (listCount < 1) {
        break;
      }
      i++;
    }
  }, []);

  // 이벤트 신청하기
  const handleEventApply = (targetId: any) => {
    if (window.confirm('해당 이벤트를 신청하시겠습니까?')) {
      const sendItems = {
        customerId: localStorage.getItem('userCusID'),
        id: targetId,
      }

      api.post('customer/api/v1/CU_010_004', sendItems)
        .then(res => {
          if (res.data.message == 'SUCCESS') {
            alert('이벤트 신청이 완료되었습니다.');
          } else {
            alert('이미 신청된 이벤트입니다.');
          }
        })
        .catch(err => {
          notifyApiError(err, '이벤트를 신청하지 못했습니다.');
        })
    } else {
      return;
    }
  }

  return (
    <Box>
      <Container sx={{ p: '0 !important', pb: '50px !important', bgcolor: '#F6F6F6', minHeight: '100vh', minWidth: 320 }}>
        <Box sx={{ bgcolor: '#dcfdd4ff', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, }} >
          {/* logo */}
          <Box position={'fixed'} width={'100%'} bgcolor={'#dcfdd4ff'} zIndex={999} maxWidth={'1200px'}>
            <Stack direction={'row'} >
              <Box>
                <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                  <Img alt="Dual" src="/dual.png" />
                </ButtonBase>
              </Box>
            </Stack>
          </Box>

          <Grid container spacing={2} direction='row' sx={{ mt: 6 }}>

            <Grid container item xs sx={{ pl: 2 }} direction='column' justifyContent='center' alignContent={'center'}>
              <Typography sx={{ fontSize: '2.2rem', color: '#38a92eff', fontWeight: 900, }}>
                이벤트
              </Typography>
            </Grid>
            <Grid sx={{ width: '45%', mr: 1, pt: 0, pl: 0 }} justifyContent='center' alignContent={'center'}>
              <Img alt="care" src={noticeimg} />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ pt: 1 }}>
          <Typography sx={{ m: '20px auto 30px auto', width: '100%', textAlign: 'center', fontSize: 16, fontWeight: 600, color: '#555', }}>새로운 소식을 확인하세요.</Typography>
          <Box sx={eventBox}>

            {eventList.map((item: any, index) => (
              <Accordion key={index}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack direction={'row'}>
                      {
                        item.recruitment
                          ? <Chip label="모집중" color="success" size="small" sx={{ mr: 2, ml: 'auto'}} />
                          : <Chip label="모집종료" sx={{ bgcolor: '#9e9e9e', color: '#fff', mr: 1 }} variant='outlined' size="small" />
                      }
                      <Typography sx={eventTitle}>{item.title}</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={eventDate}><CalendarMonthIcon sx={dateIcon} />{item.createDate}</Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={eventDetail}>
                    {item.content}
                  </Typography>
                  {
                    item.recruitment
                      ? <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                        <Button variant="contained" sx={{
                          bgcolor: '#24741dff', '&:hover': {
                            bgcolor: '#24741dff',
                          },
                          '&:active': {
                            bgcolor: '#24741dff',
                          },
                        }} size='small' onClick={() => handleEventApply(item.id)}>
                          이벤트 신청하기
                        </Button>
                      </Box>
                      : ''
                  }
                </AccordionDetails>
              </Accordion>
            ))}

          </Box>
        </Box>
      </Container>

      <Bottom />
    </Box>
  );
}

const eventBox = {
  mb: 4, ml: 2, mr: 2,
  boxSizing: 'border-box',
  '& .MuiAccordion-root:first-of-type': { borderTopLeftRadius: 20, borderTopRightRadius: 20, },
  '& .MuiAccordion-root:last-of-type': { borderBottomLeftRadius: 20, borderBottomRightRadius: 20, }
}

const eventTitle = {
  fontSize: 14,
  fontWeight: 700,
  color: '#555',
  mb: 1,
  pr: 2,
  /*  overflow: 'hidden',
   textOverflow: 'ellipsis',
   display: '-webkit-box',
   '-webkitLineClamp': '2',
   '-webkitBoxOrient': 'vertical' */
}

const eventDate = {
  fontSize: 12,
  color: '#777'
}

const dateIcon = {
  fontSize: 16,
  color: '#888',
  verticalAlign: 'sub',
  mr: '5px'
}

const eventDetail = {
  fontSize: 14,
  color: '#555',
  whiteSpace: 'pre-wrap'
}

export default Event;